const baseURL = "https://api.myspetz.com";

export function xWWWFormFormat(obj) {
  let objArray = Object.entries(obj);
  return objArray.reduce((acc, item) => acc + "&" + item[0] + "=" + item[1], "").slice(1);
}

export async function connect(path, options = {}, noJSON) {
  let connectionPath;
  if (path.indexOf("http") > -1) {
    connectionPath = path;
  } else {
    connectionPath = `${baseURL + `/` + path}`;
  }

  let res = await fetch(connectionPath, connectionOptions(options));
  if (res.status == 500) {
    await throwException(res);
  }
  if (res.status === 401 && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage("401");
  }
  // alert(res.status);
  if (noJSON) return res;

  return res.status === 200 ? await res.json() : res;
}

export async function throwException(response) {
  let jsonObject = await response.json();
  if (jsonObject.Message) throw new Error(jsonObject.Message);
  let message = jsonObject.message || jsonObject.error.innererror.message;
  throw new Error(message);
}

export function connectionOptions({
  body,
  method,
  headersToAdd,
  type,
  setCredentials = true,
}) {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  if (headersToAdd) {
    headersToAdd.forEach((header) => headers.append(header[0], header[1]));
  }

  if (!type) type = "GET";

  let options = {
    headers,
  };

  if (setCredentials) {
    options.credentials = "include";
  }

  if (type === "POST") {
    options = {
      ...options,
      method: method ? method : "POST",
      body: JSON.stringify(body),
    };
  } else if (type === "PATCH") {
    options = {
      ...options,
      method: method ? method : "PATCH",
      body: JSON.stringify(body),
    };
  } else if (type === "DELETE") {
    options = {
      ...options,
      method: "DELETE",
    };
  } else if (type === "GET") {
    options = {
      ...options,
      method: "GET",
    };
  }

  return options;
}

export default {
  connect,
  options: connectionOptions,
  xWWWFormFormat,
};
